import { capitalizeFirstLetter } from './commonFunctions';

const theme = capitalizeFirstLetter(String(process.env.REACT_APP_THEME));

const constant = {
  Yaantrac: 'Yaantrac',
  Ayka: 'Ayka',
  Address: 'Address',
  Radius: 'Radius',
  Location: 'Location',
  CurrentLocation: 'Current Location',
  Yes: 'Yes',
  No: 'No',
  DeleteConfirmation: 'Are you sure to delete?',
  DeleteDriver: 'Are you sure want to delete the driver?',
  DriverDeleteConfirmation:
    'Driver may be assigned to scheduled tours. Are you sure you want to proceed?',
  VehicleDeleteConfirmation:
    'Vehicle may be assigned to scheduled tours. Are you sure you want to proceed?',
  DeleteCustomer: 'Are you sure want to delete the',
  DeleteOrder: 'Are you sure want to delete the Order',
  DeleteShipper: 'Are you sure want to delete the Shipper?',
  DeleteConsignee: 'Are you sure want to delete the Consignee?',
  DeleteTrip: 'Are you sure want to delete the trip?',
  DeleteTripConfirmation:
    'Are you sure you want to delete this booking? All related scheduled items will be removed.',
  DeleteBooking: 'Are you sure want to delete the booking?',
  DeleteRoute: 'Are you sure want to delete the route configure?',
  TourRoute: 'Are you sure want to delete the tour configure?',
  TourRouteConfirmation:
    'Are you sure you want to delete this tour configuration? It may be linked to a scheduled tour. Do you want to proceed?',
  ShareToAgent: 'Are you sure want to share the reports to the agents?',
  downloadReport: 'Are you sure want to download the report?',
  GeofenceRadius: 'Geofence Radius',
  GeofenceDetails: 'Geofence Details',
  Reports: 'Report',
  Login: 'Login',
  Update: 'Update',
  Add: 'Add',
  Share: 'Share',
  Assign: 'Assign Vehicle',
  Deactive: 'Deactivate',
  ActiveStatus: 'Activate',
  RemoveDriver: 'Remove Mapping',
  Driver: 'Driver',
  Action: 'Actions',
  LicenseExpire: 'License Expire',
  LicenseExpiryDate: 'License Expiry Date',
  LicenseType: 'License Type',
  LicenseNumber: 'License Number',
  CreatedAt: 'Created At',
  CreatedOn: 'Created On',
  Email: 'Email',
  AssignedVehicle: 'Assigned Vehicle',
  Active: 'Active',
  ContactPhone: 'Mobile Number',
  FirstName: 'First Name',
  LastName: 'Last Name',
  DriverName: 'Driver Name',
  DriverID: 'Driver ID',
  LoginHeading: 'Navigate Your Journey with Confidence',
  LoginSubHead:
    '"Unlock efficiency and precision at every turn, where seamless logistics start with a single login."',
  SubHead: 'Login with any of the following',
  KeepSign: 'Keep me signed in',
  Distance: 'Distance',
  AllVehicles: 'All Vehicles',
  Vehicle: 'Vehicle',
  Vehicles: 'Vehicles',
  From: 'From',
  To: 'To',
  RadiusKM: 'Radius (KM)',
  Trips: 'Trips',
  Activate: 'Are you sure want to Activate?',
  Deactivate: 'Are you sure want to Deactivate?',
  Remove: 'Are you sure want to Remove Mapping vehicle?',
  GoToLogin: 'Go To Login',
  BackToLogin: 'Back to Login',
  ShareToWhatsapp: 'Do you want to share tour details via WhatsApp?',
  ForgotPassword: 'Forgot Password',
  UserName: 'Username',
  Password: 'Password',
  OTP: 'One Time Password',
  NewPassword: 'New Password',
  ConfirmNewPassword: 'Confirm New Password',
  Date: 'Date',
  Duration: 'Duration',
  VehicleNo: 'Vehicle No',
  StartTime: 'Start Time',
  EndTime: 'End Time',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  MyLocations: 'My Locations',
  Pin: 'Are you sure want to Pin?',
  unPin: 'Are you sure want to Unpin?',
  AverageSpeed: 'Average Speed (KMPH)',
  HikeSpeed: 'Hike Speed (KMPH)',
  Latitude: 'Latitude',
  Longitude: 'Longitude',
  Origin: 'Origin',
  Destination: 'Destination',
  KM: 'KM',
  Mins: 'Mins',
  Overspeed: 'Overspeed',
  EditOverspeed: 'Edit Overspeed',
  NoDataFound: 'No Data Found',
  View: 'View',
  Map: 'Map',
  AddNewTrip: 'Add New Trip',
  UpdateTrip: 'Update Trip',
  Feedback: 'Feedback',
  ShippingAddress: 'Shipping Address',
  CustomerEmail: 'Customer Email',
  CustomerPhone: 'Customer Phone',
  CustomerName: 'Customer Name',
  CustomerDetails: 'Customer Details',
  Hidden: 'Hidden',
  EmergencyContact: 'Emergency Contact',
  DriverLicenseNumber: 'Driver License Number',
  DriverPhone: 'Driver Phone',
  DriverDetails: 'Driver Details',
  EstimatedDeliveryDate: 'Estimated Delivery Date',
  Orders: 'Orders',
  OrderDate: 'Order Date',
  OrderID: 'Order ID',
  OrderDetails: 'Order Details',
  Optional: 'Optional',
  OrderType: 'Order Type',
  TrackingInfo: 'Tracking Info',
  Vehiclestatus: 'Vehicle status',
  Tokenexpired: 'Your session has expired !',
  Loginagain: 'Please login again to continue',
  Vehiclemapping: 'Vehicle Mapping',
  VehicleMapped: 'Vehicles Mapped',
  Profile: 'Profile',
  Notification: 'Notification',
  Notifications: 'Notifications',
  OtherNotifications: 'Other Notifications',
  ChangePassword: 'Change Password',
  Settings: 'Settings',
  PushNotifications: 'Push notifications',
  PushNotificationsMsg: `Receive notifications from ${theme}  on your PC`,
  Mail: 'Mail',
  MailMsg: `Receive notifications from ${theme} on your Mail`,
  SMSNotifications: 'SMS notifications',
  SMSNotificationsMsg: `Receive notifications from ${theme} on sms`,
  OverspeedMsg: 'Overspeed alert notification',
  Geofence: 'Geofence',
  UpdateGeofence: 'Update Geofence',
  GeofenceMapping: 'Geofence Mapping',
  GeofenceSummary: 'Geofence Summary',
  GeofenceVehicleDetails: 'Vehicle Details',
  GeofenceName: 'Geofence Name',
  MappedVehicles: 'Mapped Vehicles',

  GeofenceMsg: 'Geofence in and Geofence out notification',
  TripsMsg: 'Notification about trips (trip started, trip ended etc.,)',
  Themes: 'Themes',
  ThemeSetting: 'Theme Setting',
  DefaultTheme: 'Default Theme',
  Delete: 'Delete',
  Speed: 'Speed',
  TodayDistance: 'TodayDistance',
  TotalDistance: 'TotalDistance',
  VehicleStatus: 'VehicleStatus',
  DriverContactNo: 'Driver ContactNo',
  FleetUtilization: 'Fleet Utilization',
  TripCountStatus: ' Trip Count Status',
  vehicleGeoIn: 'Vehicles Within Geofence',
  vehicleGeoOut: 'Vehicles Outside Geofence',
  SearchVehiclesByLocation: 'Search vehicles by location',
  OverspeedL: 'Overspeed Limit',
  OverspeedLimit: 'Overspeed Limit (kmph)',
  UpdateOverspeedLimit: 'Update Overspeed Limit',
  OverspeedType: 'Overspeed Type',
  Reportgeneration: 'Report Generated Duration: ',
  VehicleDetails: 'Vehicle details: ',
  SpeedFrequency: 'Speed Frequency',
  Deliverytracking: 'Delivery Tracking',
  ViewDetails: 'View Details',
  Logistics: 'Logistics Entities',
  Trucks: 'Truck Zone',
  Loads: 'Loads',
  Inspection: 'Inspection',
  Scheduled: 'Scheduled Trips',
  Expired: 'Expired Trips',
  Completed: 'Completed Trips',
  Trailers: 'Trailers',
  Freights: 'Freights',
  DefaultView: 'Default View',
  AccountDeactive: 'Your account has been deactivated',
  contactAdmin: 'Please contact Admin',
  PrimaryVehicle: 'Primary Vehicle',
  SecondaryVehicle: 'Secondary Vehicle'
};
export default constant;
